import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import CurationPage from "./pages/curation/CurationPage";
import AddPlacePage from "./pages/addplace/AddPlacePage";
import AddCurationPage from "./pages/addcuration/AddCurationPage";
import PlaceDetailsPage from "./pages/placedetails/PlaceDetailsPage";
import EditCurationPage from "./pages/editcuration/EditCurationPage";
import EditPlacePage from "./pages/editplace/EditPlacePage";
import LandingPage from "./pages/auth/LandingPage";
import HomePage from "./pages/home/HomePage";
import LoginRedirectPage from "./pages/auth/LoginRedirectPage";
import CompleteProfilePage from "./pages/auth/CompleteProfilePage";
import InviteUserPage from "./pages/invite/InviteUserPage";
import InputCommentPage from "./pages/addcomment/InputCommentPage";
import PrivacyPage from "./pages/legal/PrivacyPage";
import TermsOfServicePage from "./pages/legal/TermsOfServicePage";
import WIP from "./pages/wip/WIP";
import MembersPage from "./pages/member/MembersPage";
import ProfilePage from "./pages/profile/ProfilePage";
import OwnProfilePage from "./pages/profile/OwnProfilePage";
import EditProfilePage from "./pages/profile/EditProfilePage";
import ImportFromGoogleMapsTutorial from "./pages/tutorial/ImportFromGoogleMaps";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import AppInviteCodePage from "./pages/appinvite/AppInviteCodePage";
import CurationMapPage from "./pages/curation/CurationMapPage";
import AddCurationSuccessPage from "./pages/addcuration/AddCurationSuccessPage";
import RemoveAccountPage from "./pages/removeaccount/RemoveAccountPage";
import AcceptInvitationPage from "./pages/invitation/AcceptInvitationPage";
import SupportTicketPage from "./pages/supportticket/SupportTicketPage";
import EditProfileInterestsPage from "./pages/profile/EditProfileInterestsPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import LoginPage from "./pages/auth/LoginPage";
import SignUpPage from "./pages/auth/SignUpPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import RoutePage from "./pages/curation/RoutePage";
import RouteMapPage from "./pages/curation/RouteMapPage";

export default function App() {

  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries
  
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyA6tqPCCywdSGNXbTLwxSyWg8hyZntWZjc",
    authDomain: "zipmapio.firebaseapp.com",
    projectId: "zipmapio",
    storageBucket: "zipmapio.firebasestorage.app",
    messagingSenderId: "651080963337",
    appId: "1:651080963337:web:94aa909f93242244bb6fd8",
    measurementId: "G-FY6TCH3RNR"
  };
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  return <BrowserRouter>
    <Routes>
      <Route path="/" element={<LandingPage analytics={analytics} />} />
      <Route path="/blog" element={<LandingPage analytics={analytics} />} />
      <Route path="/dashboard" element={<DashboardPage analytics={analytics} />} />
      <Route path="/register" element={<SignUpPage analytics={analytics} />} />
      <Route path="/login" element={<LoginPage analytics={analytics} />} />
      <Route path="/login/redirect" element={<LoginRedirectPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage analytics={analytics} />} />
      <Route path="/profile/complete" element={<CompleteProfilePage analytics={analytics} />} />
      <Route path="/:curationId" element={<CurationPage analytics={analytics} />} />
      <Route path="/:curationId/list" element={<CurationPage analytics={analytics} forceList={true} />} />
      <Route path="/:curationId/map" element={<CurationMapPage analytics={analytics} />} />
      <Route path="/:curationId/:id" element={<PlaceDetailsPage analytics={analytics} />} />
      <Route path="/:curationId/route/:routeId" element={<RoutePage analytics={analytics} />} />
      <Route path="/:curationId/route/:routeId/list" element={<RoutePage analytics={analytics} forceList={true} />} />
      <Route path="/:curationId/route/:routeId/map" element={<RouteMapPage analytics={analytics} />} />
    </Routes>
  </BrowserRouter>
}